// KinposPaymentBridge.notifyFirst() only ever calls ONE "void"-mode subscriber (by design: a
// device only ever has a single void in flight at a time). Historically that single subscriber was
// always ModalReturn's own local handler, because ModalReturn was the only code path that could
// start a "void" operation.
//
// With cross-point KinPOS devolution, a second code path can now start a "void" operation on this
// same device: KinposRemoteVoidExecutor, executing a void on behalf of another point (B) that
// doesn't have the physical terminal. Both ModalReturn and the executor need to react to "void"
// results, but only one of them started any given void. This module is the single subscriber
// registered against the bridge; it dispatches each result to whichever side actually started it,
// using the `remote_relay` marker embedded in the void's persisted context (see
// KinposRemoteVoidRelay.tagContextForRemoteRelay). This keeps KinposPaymentBridge itself untouched.
import { kinposPaymentBridge } from "./KinposBridge";

let localHandler = null;
let remoteHandler = null;
let unsubscribeFromBridge = null;

export const isRemoteRelayVoidResult = (result) => Boolean(result?.request?.context?.remote_relay);

const dispatch = (result) => {
   const handler = isRemoteRelayVoidResult(result) ? remoteHandler : localHandler;
   if (typeof handler !== "function") return undefined;
   return handler(result);
};

const ensureSubscribed = () => {
   if (unsubscribeFromBridge) return;
   unsubscribeFromBridge = kinposPaymentBridge.subscribe("void", dispatch);
};

// Registered by ModalReturn (both trees): handles voids that THIS device started locally for its
// own devolution flow. Unchanged behavior from before cross-point routing existed.
export const registerLocalKinposVoidHandler = (handler) => {
   ensureSubscribed();
   localHandler = handler;
   return () => {
      if (localHandler === handler) localHandler = null;
   };
};

// Registered by KinposRemoteVoidExecutor: handles voids that THIS device executed on behalf of
// another point.
export const registerRemoteKinposVoidHandler = (handler) => {
   ensureSubscribed();
   remoteHandler = handler;
   return () => {
      if (remoteHandler === handler) remoteHandler = null;
   };
};
